import moment from 'jalali-moment';
import { getLanguage } from '../i18n';

// persian: jalali calendar, english: gregorian
export const parseDate = (date, noTime = false) => {
  const converted = new Date(date);
  if (getLanguage() === 'en') {
    const enDate = converted.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
    const enTime = converted.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit'
    });
    return noTime ? `${enDate}` : `${enDate} - ${enTime}`;
  }
  const jDate = converted.toLocaleDateString('fa-IR');
  const jTime = converted.toLocaleTimeString('fa-IR').slice(0, -3);
  return noTime ? `${jDate}` : `${jDate} - ${jTime}`;
};

export const parseBirthday = (birthday) => {
  const value = birthday.split('/');
  const key = ['year', 'month', 'day'];
  const json = {};
  key.forEach((v, i) => {
    json[v] = Number(value[i]);
  });
  return json;
};

export const presentationBirthday = (birthday) => {
  const language = getLanguage();
  const birthdayMoment = moment.from(birthday, 'en').locale(language);
  return language === 'en'
    ? birthdayMoment.format('MMMM D')
    : `${birthdayMoment.format('D')} ${birthdayMoment.format('MMMM')}`;
};
